import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { adminStoreQuery } from '../../graphql/queries';
import {
  StoreDetailContainer,
  StoreImageContainer,
  StoreImage,
  StoreName,
  StoreLocation,
  ImageOverlay,
  BottomContainer,
  ButtonContainer,
} from './styled';
import Menu from './Menu';
import Button from '../../components/Button';
import Color from '@/utils/color';
import StoreEditModal from './StoreEditModal';
import CopyPasteContextProvider from '../../providers/CopyPasteContextProvider';
import Icon from '../../components/Icon';
import { FaFilePdf } from 'react-icons/all';
import { IconButton } from '../../components/Button/Button';
import i18n from '@/utils/i18n';

function StoreDetail({
  match: {
    params: { storeId },
  },
}) {
  //let { basket, writeCache, store: currentStore } = useContext(SessionContext)
  let basket = null;

  const [editingStore, setEditingStore] = useState(false);
  console.log('StoreDetail', storeId);
  function closeEditStoreModal() {
    setEditingStore(false);
  }

  function onEditStoreClick() {
    setEditingStore(true);
  }

  const { data = { store: null } } = useQuery(adminStoreQuery, {
    variables: { id: storeId },
    /*
    onCompleted: (storeData) => {
      if (storeData && storeData.store) {
        let newCache = { store: storeData.store }
        if (currentStore && currentStore.id !== storeData.store.id) {
          newCache = { ...newCache, basket: null }
        }
        writeCache(newCache)
      }
    },*/
  });

  const { store } = data;

  console.log('StoreDetail', store, data);

  return store ? (
    <div className="container-lg mt-5">
      <IconButton
        className="mb-3"
        label={i18n.t('Menu:guidelineForCreatingMenu')}
        icon={<FaFilePdf />}
        tag="a"
        href="https://drive.google.com/file/d/1W_dhJzWzjHFH3924reGZDq2L1SQ_fE-K/view?usp=sharing"
        target="_blank"
      />
      <CopyPasteContextProvider>
        <StoreDetailContainer className="preorder-style">
          <StoreImageContainer>
            <ImageOverlay />
            <StoreImage src={store.banner} />
            <BottomContainer>
              <StoreName>{store.name.toUpperCase()}</StoreName>
              <ButtonContainer>
                <Button small color={Color.Cyan} onClick={onEditStoreClick}>
                  <Icon name="edit" paddingTop={3} />
                  {` ${i18n.t('Menu:editCategoryOrder')}`}
                </Button>
                {/*
              <ButtonSpacer />
              <a href={`/de/store/${storeId}/orders`}>
                <Button small color={Color.Cyan}>
                  <Icon name="cart" />
                  {' View Orders'}
                </Button>
              </a>
              */}
              </ButtonContainer>
              <StoreLocation icon="mapPin" color="#fff">
                {store.location_name}
              </StoreLocation>
              {/*
            <BottomButtonsContainer>
              <PickupTimeSelector store={store} />
            </BottomButtonsContainer> */}
            </BottomContainer>
          </StoreImageContainer>
          <Menu
            storeId={storeId}
            brandId={store ? store.brand.id : null}
            basket={basket}
          />
          {editingStore && (
            <StoreEditModal store={store} onClose={closeEditStoreModal} />
          )}
        </StoreDetailContainer>
      </CopyPasteContextProvider>
    </div>
  ) : null;
}

StoreDetail.propTypes = {
  match: PropTypes.object.isRequired,
};

export default StoreDetail;
